import { createSlice } from "@reduxjs/toolkit";
import { Shelf, SHELF_INITIAL_VALUES } from "../models/Shelf";
import { TreeParameters } from "../models/TreeParameter";

const FormsInitialState: {
  shelfSelectedInTree: Shelf;
  shelves: Shelf[];
  openShelves: { [treeId: number | string]: number | string };
  shelvesNodes: TreeParameters[];
} = {
  shelfSelectedInTree: SHELF_INITIAL_VALUES,
  shelves: [],
  openShelves: {},
  shelvesNodes: [],
};

export const ShelvesReducer = createSlice({
  name: "__",
  initialState: FormsInitialState,
  reducers: {
    setShelfSelectedInTree(state, { payload }) {
      state.shelfSelectedInTree = payload;
    },
    setShelves(state, { payload }) {
      state.shelves = payload;
    },
    setOpenShelves(state, { payload }) {
      state.openShelves = payload;
    },
    setShelvesNodes(state, { payload }) {
      state.shelvesNodes = payload;
    },
  },
});
